export interface ResponseModeFormSettings {
  responseMode: "keyword" | "intelligent";
  customKeywords: string[];
  confidenceThreshold: number;
  eventResponderEnabled: boolean;
  dontRepeatModerators: boolean;
  moderatorDelay: number;
}

/**
 * Builds the PUT /api/bot/response-mode body.
 *
 * The backend rejects (403) any request from a free user that carries
 * eventResponderEnabled/dontRepeatModerators = true, and eventResponderEnabled
 * defaults to true on every bot instance. Sending the full settings object
 * therefore made every free-tier save fail, including plain keyword edits.
 * Free users can't change the event responder fields in the UI, so leave them
 * out and keep the stored values untouched.
 */
export const buildResponseModePayload = (
  settings: ResponseModeFormSettings,
  isPremium: boolean,
): Partial<ResponseModeFormSettings> => {
  if (isPremium) {
    return settings;
  }

  return {
    responseMode: "keyword",
    customKeywords: settings.customKeywords,
    confidenceThreshold: settings.confidenceThreshold,
  };
};
